theme.videoReelsControls = (function () {
  function VideoReelsControls(container) {
    this.container = container;
    this.videos = container.querySelectorAll('.video-reel__video');
    this.autoplay = container.dataset.autoplayVideo === 'true';
    this.init();
  }

  VideoReelsControls.prototype.init = function () {
    this.videos.forEach((video, i) => {
      const slide = video.closest('.video-reels__slide');
      const thumbnail = slide?.querySelector('.video-reel__thumbnail');
      const playBtn = slide?.querySelector('.video-reel__play-pause');
      const muteBtn = slide?.querySelector('.video-reel__mute-unmute');
      video.load();

      playBtn?.addEventListener('click', e => {
        e.preventDefault();
        video.paused ? video.play() : video.pause();
      });

      muteBtn?.addEventListener('click', e => {
        e.preventDefault();
        video.muted = !video.muted;
        this.toggleIcon(muteBtn, video.muted, 'mute');
      });

      video.addEventListener('play', () => {
        this.toggleIcon(playBtn, false, 'play');
        video.dataset.playing = 'true';
        if (thumbnail) thumbnail.style.opacity = '0';
      });

      video.addEventListener('pause', () => {
        this.toggleIcon(playBtn, true, 'play');
        video.dataset.playing = 'false';
        if (thumbnail) thumbnail.style.opacity = '1';
      });

      video.addEventListener('loadedmetadata', () => {
        this.toggleIcon(playBtn, video.paused, 'play');
        this.toggleIcon(muteBtn, video.muted, 'mute');
      });

      video.pause();
      video.muted = true;

      if (!this.autoplay || (this.autoplay && i === 0)) {
        video.muted = !this.autoplay;
        video.play().catch(() => {
          video.muted = true;
          video.play().catch(() => {});
        });
      }
    });

    if (this.autoplay) this.observeActiveSlide();
  };

  VideoReelsControls.prototype.toggleIcon = function (btn, state, type) {
    if (!btn) return;
    const on = btn.querySelector(`.video-reel__${type}-icon`);
    const off = btn.querySelector(`.video-reel__${type === 'play' ? 'pause' : 'unmute'}-icon`);
    if (on) on.style.display = state ? 'block' : 'none';
    if (off) off.style.display = state ? 'none' : 'block';
  };

  VideoReelsControls.prototype.observeActiveSlide = function () {
    const slider = this.container.querySelector('.productSlider');
    if (!slider) return;

    const playActive = () => {
      this.videos.forEach(v => (v.pause(), v.muted = true));
      const active = slider.querySelector('.swiper-slide-active .video-reel__video');
      if (active) {
        active.muted = false;
        active.play().catch(() => {
          active.muted = true;
          active.play().catch(() => {});
        });
      }
    };

    new MutationObserver(mutations => {
      mutations.forEach(m =>
        m.attributeName === 'class' &&
        m.target.classList.contains('swiper-slide-active') &&
        playActive()
      );
    }).observe(slider, { subtree: true, attributes: true, attributeFilter: ['class'] });

    const waitForSwiper = (count = 0) => {
      if (slider.swiper) {
        slider.swiper.on('slideChange', playActive);
        setTimeout(playActive, 100);
      } else if (count < 10) {
        setTimeout(() => waitForSwiper(count + 1), 200);
      }
    };
    waitForSwiper();
  };

  VideoReelsControls.prototype.onUnload = function () {
    this.videos.forEach(v => v.pause?.());
  };

  return VideoReelsControls;
})();

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.video-reels__section').forEach(s => {
    s.videoReelsControls = new theme.videoReelsControls(s);
  });
});

if (Shopify?.designMode) {
  document.addEventListener('shopify:section:load', e => {
    const s = e.target.querySelector('.video-reels__section');
    if (s) s.videoReelsControls = new theme.videoReelsControls(s);
  });
  document.addEventListener('shopify:section:unload', e => {
    const s = e.target.querySelector('.video-reels__section');
    s?.videoReelsControls?.onUnload();
  });
}
